import React, { FC, useContext, useEffect, useState } from 'react';

import { DateRangePicker, Separator, Toggle } from '@smartshell/ui-kit';
import dayjs from 'dayjs';
import { Controller } from 'react-hook-form';

import { LocalizationContext } from 'localization';

import s from './FormComponents.module.scss';
import { IFormComponentsProps } from './interfaces';

export const ActiveAndPeriod: FC<
  Pick<IFormComponentsProps, 'control' | 'setValue'> & {
    activeTo: string | null;
    activeFrom: string | null;
  }
> = ({ control, setValue, activeFrom, activeTo }) => {
  const { t, lang } = useContext(LocalizationContext);

  // const today = dayjs();

  const [period, setPeriod] = useState<boolean>(false);
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);

  useEffect(() => {
    if (activeFrom && activeTo) {
      setPeriod(true);
      setStartDate(activeFrom);
      setEndDate(activeTo);
    }
  }, [activeTo, activeFrom]);

  useEffect(() => {
    if (period) {
      setValue('activeFrom', startDate);
      setValue('activeTo', endDate);
    } else {
      setValue('activeFrom', null);
      setValue('activeTo', null);
    }
  }, [period]);

  useEffect(() => {
    setValue('activeFrom', startDate);
    setValue('activeTo', endDate);
  }, [startDate, endDate]);

  return (
    <div className={s.frame_2}>
      <Controller
        render={({ field: { name, ...field } }) => (
          <Toggle
            label={t('account.status.active')}
            {...field}
            className={s.toggle}
          />
        )}
        name="active"
        control={control}
      />

      <Separator />

      <Toggle
        value={period}
        onChange={() => setPeriod(!period)}
        label={t('period.action')}
        className={s.toggle}
      />

      {period && (
        <div className={s.date}>
          <DateRangePicker
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            firstValidDate={dayjs('2022-03-01T00:00:00').format()}
            lang={lang}
          />
        </div>
      )}
    </div>
  );
};
